/** @format */
import {
	addToSetClicked,
	removeFromSetClicked,
	skuResolved,
	userSetInputQuantity
} from './bundles.actions';
import { createReducer, on } from '@ngrx/store';

import { BundlesState } from '@pdp/data-access/interfaces';

export const initialBundleState: BundlesState = {
	selectedSkus: []
};

export const bundlesReducers = createReducer(
	initialBundleState,
	on(addToSetClicked, (state, { sku }) => {
		const updatedSelectedSkus = [...state.selectedSkus];
		updatedSelectedSkus.push(sku);
		return {
			...state,
			selectedSkus: updatedSelectedSkus
		};
	}),
	on(removeFromSetClicked, (state, { skuId }) => {
		let updatedSelectedSkus = [...state.selectedSkus];
		updatedSelectedSkus = updatedSelectedSkus.filter(
			(product) => product.sku.partNumber !== skuId
		);
		return {
			...state,
			selectedSkus: updatedSelectedSkus
		};
	}),
	on(skuResolved, (state, { oldSku, newSku, quantity }) => {
		let updatedSelectedSkus = [...state.selectedSkus];

		if (oldSku) {
			updatedSelectedSkus = updatedSelectedSkus.filter(
				(product) => product.sku.partNumber !== oldSku.partNumber
			);
		}

		if (newSku) {
			updatedSelectedSkus.push({ quantity, sku: newSku });
		}

		return {
			...state,
			selectedSkus: updatedSelectedSkus
		};
	}),
	on(userSetInputQuantity, (state, { sku, quantity }) => {
		const updatedSelectedSkus = state.selectedSkus.map((product) =>
			product.sku.partNumber === sku.partNumber ? { ...product, quantity } : product
		);
		return {
			...state,
			selectedSkus: updatedSelectedSkus
		};
	})
);

export const bundlesReducer = (state, action) => bundlesReducers(state, action);
